(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('Integration', Integration)
        .factory('IntegrationScope', IntegrationScope);

    Integration.$inject = ['$resource'];

    function Integration($resource) {
        var resourceUrl = 'api/integration/:id';

        return $resource(resourceUrl, {}, {
            'save': {method: 'POST'},
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.objectAddata = angular.fromJson(data.objectAddata);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }

    IntegrationScope.$inject = ['$resource'];

    function IntegrationScope($resource) {
        var resourceUrl = 'api/scope/:scope';

        return $resource(resourceUrl, {}, {
            'save': {method: 'POST'},
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.objectAddata = angular.fromJson(data.objectAddata);
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
